import { DatePipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";
import * as moment from "moment";

@Pipe({
  name: "dateFilter",
})
export class DateFilterPipe implements PipeTransform {
  transform(
    value: any,
    key: string,
    dateBefore: string,
    dateAfter: string
  ): any {
    const pipe = new DatePipe("en-US");
    if (!dateBefore || dateBefore == "") {
      dateBefore = "1800-10-01";
    }
    if (!dateAfter || dateAfter == "") {
      dateAfter = "3000-01-01";
    }
    let fechaBefore = new Date(dateBefore);
    fechaBefore.setDate(fechaBefore.getDate());
    dateBefore = fechaBefore.toString();
    let fechaAfter = new Date(dateAfter);
    fechaAfter.setDate(fechaAfter.getDate() + 1);
    dateAfter = fechaAfter.toString();
    dateBefore = pipe.transform(dateBefore, "yyyy-MM-dd");
    dateAfter = pipe.transform(dateAfter, "yyyy-MM-dd");

    if (value.length > 0) {
      return value.filter(function (dateItem: any) {
        let fechaFiltro = pipe.transform(dateItem[key], "yyyy-MM-dd");
        return (
          moment.utc(fechaFiltro).isAfter(dateBefore) &&
          moment.utc(fechaFiltro).isBefore(dateAfter)
        );
      });
    }
    return value;
  }
}
